/* MONA theme — interactions. Everything here enhances markup that already works without JavaScript. */
(function () {
  'use strict';

  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  /* ---------- Header: solid background once the page scrolls ---------- */
  var headerGroup = document.querySelector('[data-header-group]');
  if (headerGroup && headerGroup.classList.contains('header-group--overlay')) {
    var onScroll = function () { headerGroup.classList.toggle('is-scrolled', window.scrollY > 40); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Menu panel (phones and narrower screens) ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var menuPanel = document.querySelector('[data-menu-panel]');
  var menuLabel = document.querySelector('[data-menu-label]');

  function setMenu(open) {
    if (!menuToggle || !menuPanel) return;
    menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (menuLabel) menuLabel.textContent = open ? 'Затвори' : 'Меню';
    if (open) {
      menuPanel.removeAttribute('inert');
      menuPanel.setAttribute('data-open', '');
    } else {
      menuPanel.removeAttribute('data-open');
      menuPanel.setAttribute('inert', '');
    }
    document.body.classList.toggle('menu-open', open);
    if (headerGroup) headerGroup.classList.toggle('is-menu-open', open);
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      setMenu(menuToggle.getAttribute('aria-expanded') !== 'true');
    });
  }

  /* Submenus inside the panel (e.g. „Музика“) open and close with a tap. */
  document.querySelectorAll('[data-sub-toggle]').forEach(function (btn) {
    var sub = document.getElementById(btn.getAttribute('aria-controls'));
    if (!sub) return;
    sub.querySelectorAll('a').forEach(function (a) { a.tabIndex = -1; });
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      sub.toggleAttribute('data-open', open);
      sub.querySelectorAll('a').forEach(function (a) { a.tabIndex = open ? 0 : -1; });
    });
  });

  /* Desktop dropdowns: click or Enter/Space to open, Esc or a click elsewhere to close. */
  var dropdownToggles = document.querySelectorAll('[data-dropdown-toggle]');

  function closeDropdowns(except) {
    dropdownToggles.forEach(function (btn) {
      if (btn === except) return;
      btn.setAttribute('aria-expanded', 'false');
      var dd = document.getElementById(btn.getAttribute('aria-controls'));
      if (dd) dd.removeAttribute('data-open');
    });
  }

  dropdownToggles.forEach(function (btn) {
    var dd = document.getElementById(btn.getAttribute('aria-controls'));
    if (!dd) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      closeDropdowns(btn);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      dd.toggleAttribute('data-open', open);
    });
    btn.parentElement.addEventListener('focusout', function (e) {
      if (!btn.parentElement.contains(e.relatedTarget)) {
        btn.setAttribute('aria-expanded', 'false');
        dd.removeAttribute('data-open');
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element) || e.target.closest('.nav__item')) return;
    closeDropdowns();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openDropdown = document.querySelector('[data-dropdown-toggle][aria-expanded="true"]');
    if (openDropdown) {
      closeDropdowns();
      openDropdown.focus();
      return;
    }
    if (menuToggle && menuToggle.getAttribute('aria-expanded') === 'true') {
      setMenu(false);
      menuToggle.focus();
    }
  });

  /* The menu button only exists below 1200px; close the panel if the screen grows past it. */
  if (window.matchMedia) {
    var wide = window.matchMedia('(min-width: 1200px)');
    var onWide = function () { if (wide.matches) setMenu(false); };
    if (wide.addEventListener) wide.addEventListener('change', onWide);
  }

  /* Same-page links (e.g. /#zhiva) close the menu. */
  if (menuPanel) {
    menuPanel.addEventListener('click', function (e) {
      var link = e.target instanceof Element ? e.target.closest('a') : null;
      if (link && link.hash && link.pathname === window.location.pathname) setMenu(false);
    });
  }

  /* ---------- Sections fade in as they reach the screen ---------- */
  var revealEls = document.querySelectorAll('[data-reveal]');
  var designMode = window.Shopify && window.Shopify.designMode;
  if (designMode) document.documentElement.classList.add('design-mode');
  if (!designMode && 'IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- After a form posts, bring its message into view ---------- */
  var autofocusEl = document.querySelector('[data-autofocus]');
  if (autofocusEl) {
    window.setTimeout(function () {
      autofocusEl.scrollIntoView({ block: 'center' });
      autofocusEl.focus({ preventScroll: true });
    }, 120);
  }

  /* ---------- Toast ---------- */
  var toast = document.getElementById('Toast');
  var toastTimer = null;

  function showToast(message) {
    if (!toast) return;
    toast.querySelector('[data-toast-text]').textContent = message;
    toast.setAttribute('data-show', '');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () { toast.removeAttribute('data-show'); }, 5000);
  }

  if (toast) {
    var closeToast = toast.querySelector('[data-toast-close]');
    if (closeToast) closeToast.addEventListener('click', function () { toast.removeAttribute('data-show'); });
  }

  /* ---------- Cart count ---------- */
  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    document.querySelectorAll('[data-cart-count-wrap]').forEach(function (el) { el.hidden = count === 0; });
    document.querySelectorAll('[data-cart-label]').forEach(function (el) {
      el.textContent = 'Количка, ' + count + (count === 1 ? ' продукт' : ' продукта');
    });
  }

  /* ---------- Add to cart (AJAX with normal form fallback) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-product-form')) return;
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var error = form.querySelector('[data-form-error]');
    var label = button ? button.innerHTML : '';
    if (button) { button.setAttribute('aria-disabled', 'true'); button.textContent = 'Добавяме…'; }
    if (error) { error.hidden = true; error.textContent = ''; }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) throw new Error(result.data.description || result.data.message || 'Не успяхме да добавим продукта.');
        showToast('Добавихме „' + result.data.product_title + '“ в количката.');
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { setCartCount(cart.item_count); });
      })
      .catch(function (err) {
        if (error) { error.textContent = err.message; error.hidden = false; }
      })
      .finally(function () {
        if (button) { button.removeAttribute('aria-disabled'); button.innerHTML = label; }
      });
  });

  /* ---------- Variant picker ---------- */
  document.querySelectorAll('[data-product]').forEach(function (product) {
    var dataEl = product.querySelector('[data-product-json]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var form = product.querySelector('[data-product-form]');
    var idInput = form ? form.querySelector('input[type="hidden"][name="id"]') : null;
    var button = form ? form.querySelector('[type="submit"]') : null;
    var priceEl = product.querySelector('[data-price]');
    var fallbackSelect = product.querySelector('[data-variant-select]');
    var pickers = product.querySelectorAll('[data-option-index]');

    if (fallbackSelect && pickers.length) {
      var select = fallbackSelect.querySelector('select');
      fallbackSelect.hidden = true;
      if (select) select.disabled = true;
      idInput = form ? form.querySelector('input[type="hidden"][name="id"]') : null;
      if (idInput) idInput.disabled = false;
    }

    function selected() {
      var values = [];
      pickers.forEach(function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        values[Number(fieldset.getAttribute('data-option-index'))] = checked ? checked.value : null;
      });
      return values;
    }

    function money(cents) {
      return (cents / 100).toLocaleString('bg-BG', { style: 'currency', currency: data.currency || 'EUR' });
    }

    function update() {
      var values = selected();
      var variant = data.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === values[i]; });
      });

      if (!variant) {
        if (button) { button.disabled = true; button.textContent = 'Няма такъв вариант'; }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? 'Добави в количката' : 'Изчерпано';
      }
      if (priceEl) {
        var html = '<span class="price__now">' + money(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += ' <s><span class="visually-hidden">Стара цена</span>' + money(variant.compare_at_price) + '</s>';
          priceEl.classList.add('price--sale');
        } else {
          priceEl.classList.remove('price--sale');
        }
        priceEl.innerHTML = html;
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      if (variant.featured_media_id) {
        var slide = product.querySelector('[data-media-id="' + variant.featured_media_id + '"]');
        if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }

    pickers.forEach(function (fieldset) { fieldset.addEventListener('change', update); });
  });

  /* ---------- Gallery thumbs ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('.gallery__main');
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var target = gallery.querySelector('[data-media-id="' + thumb.getAttribute('data-thumb') + '"]');
        if (!target || !track) return;
        track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target instanceof Element ? e.target.closest('[data-qty-step]') : null;
    if (!step) return;
    var input = step.parentElement.querySelector('input');
    if (!input) return;
    var min = Number(input.min || 0);
    var next = Math.max(min, Number(input.value || 0) + Number(step.getAttribute('data-qty-step')));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart page: quantity change submits the cart form so totals stay correct. */
  document.querySelectorAll('[data-cart-form]').forEach(function (form) {
    var timer;
    form.addEventListener('change', function (e) {
      if (!(e.target instanceof HTMLInputElement) || e.target.type !== 'number') return;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { form.submit(); }, 600);
    });
  });

  /* ---------- Copy buttons ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target instanceof Element ? e.target.closest('[data-copy]') : null;
    if (!btn || !navigator.clipboard) return;
    var value = btn.getAttribute('data-copy');
    var status = document.getElementById(btn.getAttribute('data-status'));
    var textEl = btn.querySelector('.copy-btn__text') || btn;
    var label = btn.getAttribute('data-label') || textEl.textContent.trim();
    btn.setAttribute('data-label', label);
    navigator.clipboard.writeText(value).then(function () {
      btn.setAttribute('data-copied', '');
      textEl.textContent = 'Копирано';
      if (status) status.textContent = 'Копирано: ' + value;
      window.setTimeout(function () { btn.removeAttribute('data-copied'); textEl.textContent = label; }, 2000);
    }, function () {
      if (status) status.textContent = 'Копирането не се получи. Маркирай текста и го копирай ръчно.';
    });
  });

  /* ---------- Song player (tracklist): plays the YouTube video in a dialog ---------- */
  var player = document.getElementById('Player');
  if (player && typeof player.showModal === 'function') {
    var frame = player.querySelector('[data-player-frame]');
    var titleEl = player.querySelector('[data-player-title]');
    var openedFrom = null;

    document.addEventListener('click', function (e) {
      var trigger = e.target instanceof Element ? e.target.closest('[data-play]') : null;
      if (!trigger) return;
      openedFrom = trigger;
      var id = trigger.getAttribute('data-play');
      var title = trigger.getAttribute('data-title') || '';
      if (titleEl) titleEl.textContent = title;
      frame.innerHTML = '';
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
      iframe.title = title || 'Видео';
      iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      frame.appendChild(iframe);
      player.showModal();
    });

    player.addEventListener('close', function () {
      frame.innerHTML = '';
      if (openedFrom) openedFrom.focus();
    });

    player.addEventListener('click', function (e) {
      if (e.target === player) player.close();
    });
  } else {
    /* Very old browsers: open the song on YouTube instead. */
    document.addEventListener('click', function (e) {
      var trigger = e.target instanceof Element ? e.target.closest('[data-play]') : null;
      if (trigger) window.open('https://www.youtube.com/watch?v=' + encodeURIComponent(trigger.getAttribute('data-play')), '_blank', 'noopener');
    });
  }

  /* ---------- YouTube: load the player only after a click ---------- */
  document.addEventListener('click', function (e) {
    var play = e.target instanceof Element ? e.target.closest('[data-youtube]') : null;
    if (!play) return;
    var id = play.getAttribute('data-youtube');
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
    iframe.title = play.getAttribute('aria-label') || 'Видео';
    iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    play.parentElement.appendChild(iframe);
    play.remove();
    iframe.focus();
  });
})();
